<script>
    import HeadingContent from "./component/HeadingContent.svelte";

    import { section } from "../store/section.js";

    import { active_workspace } from "../store/workspace.js";
    import { active_subscription } from "../store/subscription.js";

    import { workspace_list } from "../store/workspace_list.js";

    import { refresh } from "../store/refresh.js";
    import { token } from "../store/token.js";

    import { blur } from "svelte/transition";
    import { slide } from "svelte/transition";

    export let check_error;

    import {
        fetch_workspace_billing_info,
        fetch_workspace_member_list,
    } from "../api/request.js";

    let workspace_title = $active_workspace.title;
    let error_message;
    let success_message;

    const STORAGE_ADDON_TO_READABLE_TITLE_MAPPING = {
        undefined: "250 GB",
        "1-tb-storage-yearly": "1 TB",
        "2-tb-storage-yearly": "2 TB",
        "3-tb-storage-yearly": "3 TB",
        "5-tb-storage-yearly": "5 TB",
    };

    console.log($active_workspace);

    const set_section = (selected_section) => {
        section.set(selected_section);
    };

    const cancel_subscription = (subscription) => {
        confirm(`Do you really want to cancel subscription?`);
    };

    // ----

    $: price_per_seat_usd =
        available_plan[plan_selection].tiers[0].price / 100 / 12;

    let seat_count = 20;

    $: {
        if (
            seat_count <= billing_info.seat_limits[plan_selection].max &&
            seat_count >= billing_info.seat_limits[plan_selection].min
        ) {
        } else if (seat_count < billing_info.seat_limits[plan_selection].min) {
            seat_count = billing_info.seat_limits[plan_selection].min;
        } else if (seat_count > billing_info.seat_limits[plan_selection].max) {
            seat_count = billing_info.seat_limits[plan_selection].max;
        }
    }

    let month_count = 12;

    let storage_selection = "250";
    let plan_selection = "workspace-seats-yearly";

    let billing_info = {
        seat_limits: {
            "workspace-seats-yearly": {
                min: 20,
                max: 9999,
            },
        },
    };

    let available_plan = {
        "workspace-seats-yearly": {
            tiers: [{ price: 5000 }],
        },
    };

    let cb_instance;
    let cb_portal;

    const STORAGE_TO_PRICE_USD_MAPPING = {
        "250": 0,
        "1-tb-storage-yearly": 300,
        "2-tb-storage-yearly": 600,
        "5-tb-storage-yearly": 1500,
    };

    const STORAGE_TO_READABLE_TITLE_MAPPING = {
        "250": "250 GB",
        "1-tb-storage-yearly": "1 TB",
        "2-tb-storage-yearly": "2 TB",
        "5-tb-storage-yearly": "5 TB",
    };

    /*
    const initChargebee = async () => {
        if (window.Chargebee == undefined) {
            return setTimeout(() => {
                initChargebee();
            }, 500);
        }

        cb_instance = window.Chargebee.init({
            site: `${process.env.CHARGEBEE_SITE}`,
        });

        var billing_portal_workspace_url = new URL(
            `${process.env.API_ROOT}/billing/portal/workspace/session`
        );

        const billing_portal_workspace_response = await fetch(
            billing_portal_workspace_url,
            {
                method: "post",
                headers: {
                    Authorization: "Bearer " + $token,
                    "control-workspace": $active_workspace.string_id,
                },
            }
        );

        var billing_portal_workspace_json =
            await billing_portal_workspace_response.json();

        cb_instance.setPortalSession(function () {
            return new Promise(function (resolve, reject) {
                resolve(billing_portal_workspace_json);
            });
        });

        cb_portal = cb_instance.createChargebeePortal();
    };
    */

    const openChargebeeCheckout = async () => {
        /*window.$("#next").LoadingOverlay("show", {
            background: "rgba(0, 94, 234, 1)",
            image: "/images/tail-spin.svg",
            imageAutoResize: false,
            imageColor: "rgba(255,255,255,0)",
            imageAnimation: "700ms rotate_right",
        });*/

        //await initChargebee();

        var checkout_workspace_url = new URL(
            `${process.env.API_ROOT}/billing/portal/workspace/checkout?workspace_id=${$active_workspace.string_id}`,
        );

        const checkout_workspace_response = await fetch(
            checkout_workspace_url,
            {
                method: "post",
                headers: {
                    Authorization: "Bearer " + $token,
                    "control-workspace": $active_workspace.string_id,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    plan_id: plan_selection,
                    plan_quantity: seat_count,
                    addon_id:
                        storage_selection != "250" ? storage_selection : null,
                }),
            },
        );

        var checkout_workspace_json = await checkout_workspace_response.json();

        console.log(checkout_workspace_json);
        return;
        //window.$("#next").LoadingOverlay("hide");

        cb_instance.openCheckout({
            hostedPage: () => {
                return new Promise(function (resolve, reject) {
                    resolve(checkout_workspace_json);
                });
            },
            success: function (hostedPageId) {
                /*window.$("#modal_loading").LoadingOverlay("show", {
                    background: "rgba(220, 220, 220, 1)",
                    image: "/images/tail-spin.svg",
                    imageAutoResize: false,
                    imageColor: "rgba(0,0,0,0)",
                    imageAnimation: "700ms rotate_right",
                });*/

                setTimeout(() => {
                    refresh.set("1");
                }, 9500);

                setTimeout(() => {
                    cb_instance.closeAll();
                    closeModal();
                }, 10000);
            },
        });
    };

    const fetch_sub = async (sub_id) => {
        const data = await fetch_workspace_billing_info(sub_id, $token);

        active_subscription.set(data);

        return data;
    };

    let delete_workspace_modal_shown = false;

    const show_hide_delete_workspace = () => {
        delete_workspace_modal_shown = !delete_workspace_modal_shown;
    };

    let workspace_name_delete = "";
    let workspace_name_delete_confirm = "";

    const delete_workspace = async () => {
        console.log(workspace_name_delete);
        if (
            !(
                workspace_name_delete &&
                workspace_name_delete.length > 0 &&
                workspace_name_delete == workspace_name_delete_confirm &&
                workspace_name_delete == $active_workspace.title
            )
        ) {
            alert("Workspace delete confirmation failed");
            return;
        }

        var delete_workspace_url = new URL(
            `${process.env.API_ROOT}/workspace/${$active_workspace.string_id}`,
        );

        const delete_workspace_response = await fetch(delete_workspace_url, {
            method: "delete",
            headers: {
                Authorization: "Bearer " + $token,
                "control-workspace": $active_workspace.string_id,
            },
        });

        workspace_list.set([]);

        set_section("account/workspaces");
    };
</script>

<!--
<svelte:head>
    <script
        src="https://js.chargebee.com/v2/chargebee.js"
        on:load={initChargebee()}
    ></script>
    {#if !window.Chargebee}
        <script
            src="https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js"
        ></script>
        <script
            src="https://cdn.jsdelivr.net/npm/gasparesganga-jquery-loading-overlay@2.1.7/dist/loadingoverlay.min.js"
        ></script>
    {/if}
</svelte:head>
-->

<div class="settings-holder-content content-active">
    <HeadingContent
        title={$active_workspace.title}
        back_button_enabled={true}
        back_button_click_action={() => {
            set_section("account/workspaces");
        }}
    />
    <!--
    <div class="settings-heading">
        <div
            class="heading-block"
            on:click={() => {
                set_section("account/workspaces");
            }}
        >
            <a class="nav-opener" href="#"><i class="icon icon-navigation" /></a
            ><a class="nav-back no-hover-state" href="#">
                <div class="ico-holder">
                    <i class="icon icon-chevron-left" />
                </div>
                <div class="title-holder">
                    <strong class="settings-title">{workspace_title}</strong>
                </div></a
            >
        </div>
    </div>
    -->
    {#await fetch_sub($active_workspace.string_id)}
        <div class="settings-content" in:blur>
            <div class="settings-content-holder">
                <div class="card-h-100">
                    <div class="card-evary-goods card-join-bottom card">
                        <div class="card-body">
                            <div class="card-block">
                                <div class="df-row df-aic gx-05">
                                    <div class="col-auto">
                                        <div class="logo-holder">
                                            {#if $active_workspace.image_url}
                                                <img
                                                    src={$active_workspace.image_url}
                                                    alt=""
                                                    loading="lazy"
                                                    width="48"
                                                    height="48"
                                                    class="workspace-avatar"
                                                />
                                            {:else}
                                                <img
                                                    src="https://dvr722unfp578.cloudfront.net/image/workspace_image/c5bca08aed57d9d634b8e1541cb0140a44a64d213eb8acd183ef1249272daa53.jpg"
                                                    loading="lazy"
                                                    alt=""
                                                    width="48"
                                                    height="48"
                                                    class="workspace-avatar"
                                                />
                                            {/if}
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        <div class="card-box">
                                            <div class="card-box-body">
                                                <h3 class="h6 box-title">
                                                    Loading workspace
                                                    information
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {:then billing_info}
        <div class="settings-content">
            <div class="settings-content-holder">
                <div class="card-h-100">
                    <div class="card-evary-goods card-join-bottom card">
                        <div class="card-body">
                            <div class="card-block">
                                <div class="df-row df-aic gx-05">
                                    <div class="col-auto">
                                        <div class="logo-holder">
                                            {#if $active_workspace.image_url}
                                                <img
                                                    src={$active_workspace.image_url}
                                                    alt="vollume"
                                                    width="48"
                                                    height="48"
                                                    class="workspace-avatar"
                                                />
                                            {:else}
                                                <img
                                                    src="https://dvr722unfp578.cloudfront.net/image/workspace_image/c5bca08aed57d9d634b8e1541cb0140a44a64d213eb8acd183ef1249272daa53.jpg"
                                                    loading="lazy"
                                                    alt=""
                                                    width="48"
                                                    height="48"
                                                    class="workspace-avatar"
                                                />
                                            {/if}
                                        </div>
                                    </div>
                                    <div class="col-auto">
                                        <div class="card-box">
                                            <div class="card-box-body">
                                                <h3 class="h6 box-title">
                                                    Vollume - {billing_info
                                                        .readable_super_short_title_mapping[
                                                        billing_info.plan_id
                                                    ]}
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-block">
                                <strong class="price-workspace text-white"
                                    >${billing_info.raw.arr_usd} Per year.<span
                                        class="fw-normal d-block"
                                        >
                                        <time datetime="2022-07-23"
                                            >{billing_info.next_billing_at ? 'Renews on ' + new Date(
                                                billing_info.next_billing_at,
                                            ).toDateString() : "Free plan"}</time
                                        ></span
                                    ></strong
                                >
                                <p>
                                    You’re a member of the Vollume - {$active_workspace.title}
                                    with {billing_info
                                        .readable_short_title_mapping[
                                        billing_info.plan_id
                                    ]} plan. Asset Containers, public presentations,
                                    offline playback, and {$active_workspace
                                        .info.storage_limit_gb} GB storage.
                                </p>
                                <p>
                                    <a href="#"
                                        >See available plans &amp; add-ons</a
                                    >
                                </p>
                            </div>
                            <div class="card-block">
                                {#await fetch_workspace_member_list($active_workspace.string_id, $token)}
                                    <div class="card-row df-row df-jcsb gx-1">
                                        <div class="col">
                                            <span class="seats-workspace"
                                                >Loading seats information
                                            </span>
                                        </div>
                                    </div>
                                {:then member_list}
                                    <div class="card-row df-row df-jcsb gx-1">
                                        <div class="col">
                                            <span class="seats-workspace"
                                                >Seats used <span
                                                    class="seats-workspace__used"
                                                    >{member_list.length ||
                                                        0}</span
                                                >
                                                of
                                                <span
                                                    class="seats-workspace__total"
                                                    >{billing_info.plan_quantity}</span
                                                ></span
                                            >
                                        </div>
                                        <div class="col-auto">
                                            <a
                                                class="link-sm-blue"
                                                href="#"
                                                on:click={() => {
                                                    set_section(
                                                        "account/workspaces/overview/member_list",
                                                    );
                                                }}>Manage Seats</a
                                            >
                                        </div>
                                    </div>
                                {/await}
                                <div class="card-row df-row df-jcsb gx-1">
                                    <div class="col">
                                        <span class="storage-workspace"
                                            >Storage — <span
                                                class="storage-workspace__availible"
                                                >{$active_workspace.info
                                                    .storage_limit_gb} GB</span
                                            ></span
                                        >
                                    </div>
                                    <div class="col-auto">
                                        <a
                                            class="link-sm-blue"
                                            href="#"
                                            on:click={() => {
                                                set_section(
                                                    "account/workspaces/overview/change_plan",
                                                );
                                            }}>Manage Storage</a
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="card-settings-main-footer card bg-transparent-mobile"
                >
                    <div class="card-body" style="padding: 15px">
                        <div class="df-row df-aic df-md-jce gx-1">
                            <div class="col-md-auto">
                                <a
                                    class="btn btn-dark"
                                    href="#"
                                    on:click={() => {
                                        show_hide_delete_workspace();
                                    }}>Delete workspace</a
                                >
                            </div>
                            <div class="col-md-auto">
                                <a
                                    class="btn btn-dark"
                                    href="#"
                                    on:click={() => {
                                        set_section(
                                            "account/workspaces/overview/sso_config",
                                        );
                                    }}>Configure SSO</a
                                >
                            </div>
                            <div class="col-md-auto">
                                <a
                                    class="btn btn-dark"
                                    href="#"
                                    on:click={() => {
                                        set_section(
                                            "account/workspaces/overview/billing",
                                        );
                                    }}>Billing</a
                                >
                            </div>
                            <div class="col-md-auto">
                                <a
                                    class="btn btn-primary"
                                    href="#"
                                    on:click={() => {
                                        set_section(
                                            "account/workspaces/overview/change_plan",
                                        );
                                    }}>Change Plan</a
                                >
                            </div>
                            <div class="col-md-auto">
                                <a
                                    class="btn btn-primary"
                                    href="#"
                                    on:click={() => {
                                        openChargebeeCheckout();
                                    }}>Chargebee Hosted Page</a
                                >
                            </div>
                            <!--<div class="col-md-auto">
                                <a
                                    class="btn btn-danger"
                                    href="#"
                                    on:click={() => {
                                        cancel_subscription();
                                    }}>Cancel Subscribtion</a
                                >
                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {:catch error}
        Failed to load subscription info
        {check_error(error)}
    {/await}
</div>

<div
    class="popup-overlay"
    style={delete_workspace_modal_shown == false ? "display:none" : ""}
>
    <div class="popup-container" style="margin-top:10%">
        <div class="popup-card">
            <h3 class="h6 box-title">Delete Workspace</h3>
            <div class="mb-24">
                <div class="f-white">
                    Are you sure you want to delete the {$active_workspace.title}?
                    <br /><br />
                    This action will delete all files, libraries and projects and
                    can not be undone.
                    <br /><br />
                </div>
            </div>
            <div class="mb-24">
                <div>
                    To delete this workspace, type the workspace name into the
                    fields below.
                    <br /><br />
                </div>
            </div>
            <div class="w-form">
                <form
                    id="email-form-3"
                    name="email-form-3"
                    data-name="Email Form 3"
                    method="get"
                >
                    <input
                        type="text"
                        class="field w-input"
                        maxlength="256"
                        name="name"
                        data-name="Name"
                        placeholder="Workspace name"
                        id="name"
                        bind:value={workspace_name_delete}
                    /><input
                        type="email"
                        class="field w-input"
                        maxlength="256"
                        name="email-3"
                        data-name="Email 3"
                        placeholder="Workspace name again"
                        id="email-3"
                        required=""
                        bind:value={workspace_name_delete_confirm}
                    />
                </form>
            </div>
            <div class="popup-actions">
                <div class="df-row df-aic df-md-jce gx-1">
                    <div class="col-md-auto">
                        <a
                            class="btn btn-dark"
                            href="#b"
                            on:click={() => {
                                show_hide_delete_workspace();
                            }}>Cancel</a
                        >
                    </div>
                    <div class="col-md-auto">
                        <a
                            class="btn btn-danger"
                            href="#a"
                            on:click={() => {
                                delete_workspace();
                            }}>Delete workspace</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .workspace-avatar {
        /*clip-path: circle(24px at center);*/
        clip-path: polygon(
            25.002221px 0px,
            calc(100% - 25.002221px) 0px,
            calc(100% - 22.377144px) 0.012391px,
            calc(100% - 19.753467px) 0.09098px,
            calc(100% - 17.137199px) 0.296336px,
            calc(100% - 14.542695px) 0.688136px,
            calc(100% - 12.001512px) 1.339807px,
            calc(100% - 9.562265px) 2.300647px,
            calc(100% - 7.289447px) 3.603178px,
            calc(100% - 5.267551px) 5.267551px,
            calc(100% - 3.603178px) 7.289447px,
            calc(100% - 2.300647px) 9.562265px,
            calc(100% - 1.339807px) 12.001512px,
            calc(100% - 0.688136px) 14.542695px,
            calc(100% - 0.296336px) 17.137199px,
            calc(100% - 0.09098px) 19.753467px,
            calc(100% - 0.012391px) 22.377144px,
            calc(100% - 0.012391px) calc(100% - 22.377144px),
            calc(100% - 0.09098px) calc(100% - 19.753467px),
            calc(100% - 0.296336px) calc(100% - 17.137199px),
            calc(100% - 0.688136px) calc(100% - 14.542695px),
            calc(100% - 1.339807px) calc(100% - 12.001512px),
            calc(100% - 2.300647px) calc(100% - 9.562265px),
            calc(100% - 3.603178px) calc(100% - 7.289447px),
            calc(100% - 5.267551px) calc(100% - 5.267551px),
            calc(100% - 7.289447px) calc(100% - 3.603178px),
            calc(100% - 9.562265px) calc(100% - 2.300647px),
            calc(100% - 12.001512px) calc(100% - 1.339807px),
            calc(100% - 14.542695px) calc(100% - 0.688136px),
            calc(100% - 17.137199px) calc(100% - 0.296336px),
            calc(100% - 19.753467px) calc(100% - 0.09098px),
            calc(100% - 22.377144px) calc(100% - 0.012391px),
            calc(100% - 25.002221px) 100%,
            25.002221px 100%,
            22.377144px calc(100% - 0.012391px),
            19.753467px calc(100% - 0.09098px),
            17.137199px calc(100% - 0.296336px),
            14.542695px calc(100% - 0.688136px),
            12.001512px calc(100% - 1.339807px),
            9.562265px calc(100% - 2.300647px),
            7.289447px calc(100% - 3.603178px),
            5.267551px calc(100% - 5.267551px),
            3.603178px calc(100% - 7.289447px),
            2.300647px calc(100% - 9.562265px),
            1.339807px calc(100% - 12.001512px),
            0.688136px calc(100% - 14.542695px),
            0.296336px calc(100% - 17.137199px),
            0.09098px calc(100% - 19.753467px),
            0.012391px calc(100% - 22.377144px),
            0.012391px 22.377144px,
            0.09098px 19.753467px,
            0.296336px 17.137199px,
            0.688136px 14.542695px,
            1.339807px 12.001512px,
            2.300647px 9.562265px,
            3.603178px 7.289447px,
            5.267551px 5.267551px,
            7.289447px 3.603178px,
            9.562265px 2.300647px,
            12.001512px 1.339807px,
            14.542695px 0.688136px,
            17.137199px 0.296336px,
            19.753467px 0.09098px,
            22.377144px 0.012391px,
            25.002221px 0px
        );
    }
</style>
